export default __webpack_public_path__ + "static/media/aws-iam.d3e5c273.svg";